"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
// bs-table-item-selection-actions

var _require = require('lodash'),
  get = _require.get;
var tableItemSelectionActionsCtrl = /* @ngInject */function tableItemSelectionActionsCtrl($route, $routeParams, $scope, $q, $rootScope, $window, $timeout, eventService, metadataService, bulkUpdateService, metricsService, modalService) {
  var _this = this;
  this.$window = $window;
  this.$timeout = $timeout;

  // ⚑
  // TODO: Refactor bad directive practice
  var eventId = $routeParams.eventId;
  var event = eventService.decorateScope(eventId);

  // batch selection actions to be used in the pax & agenda tables
  var rows = function rows() {
    return $scope.rowCollection;
  };
  var getAllSelectedItems = function getAllSelectedItems() {
    return _.where(rows(), {
      isSelected: true
    });
  };
  var getDocFpType = function getDocFpType() {
    return (_.first(rows()) || {}).fp_type;
  };
  var deleteMetaPropsInRow = function deleteMetaPropsInRow(row) {
    var privateFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var fieldsToDelete = _.union(
    // just to be safe (these two are set in the controller for display purposes)
    ['isInvited', 'isActivated', 'actcode'], privateFields);
    return _.omit(row, fieldsToDelete);
  };
  var getPrivateFields = function getPrivateFields() {
    var metadata = metadataService.getCachedMetadataForTypeAsArray(eventId, getDocFpType());
    return metadata.filter(function (field) {
      return field.crypt;
    }).map(function (field) {
      return field.field;
    });
  };
  $scope.getSelectedItemCount = function () {
    return getAllSelectedItems().length;
  };
  $scope.getDeleteButtonLabel = function () {
    if (getDocFpType() === 'person') {
      return 'Deactivate and cancel';
    }
    return 'Delete';
  };
  $scope.shouldShowSelectionOperationsButtons = function () {
    $scope.somethingSelected = Boolean(_.findWhere(rows(), {
      isSelected: true
    }));
    // try to do something a bit optimised
    return $scope.somethingSelected;
  };
  $scope.hideSelectedItemsInList = function () {
    var selectedItems = getAllSelectedItems();
    var _rows = _.without.apply(_, [rows()].concat(selectedItems));
    return angular.copy(_rows, rows());
  };
  $scope.shouldShowHideShowButtons = function () {
    return getDocFpType() === 'person';
  };
  $scope.shouldShowPaxRequestButtons = function () {
    return getDocFpType() === 'pax-request';
  };
  $scope.shouldShowDeleteButtons = function () {
    var currentRouteDescriptor = $route.current !== null ? $route.current.$$route : null;
    var blueprintController = get(currentRouteDescriptor, 'blueprintMetadata.controller');
    var hideDelete = get(blueprintController, 'routeOptions.crudOpts.hideDelete');
    return !hideDelete;
  };
  function initButtons() {
    return _initButtons.apply(this, arguments);
  }
  function _initButtons() {
    _initButtons = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return metadataService.getCachedDuplicateFlagForType(eventId, getDocFpType());
          case 2:
            $scope.shouldShowDuplicateButton = _context.sent;
            _context.next = 5;
            return metadataService.getCachedBulkEditFlagForType(eventId, getDocFpType());
          case 5:
            $scope.shouldShowBulkEditButton = _context.sent;
            $scope.timeShiftFields = metadataService.getCachedMetadataForTypeAsArray(eventId, getDocFpType()).filter(function (field) {
              return field._timeshift;
            });
            _context.next = 9;
            return window.BSTG.services.metadata.isFpTypeTimeShiftable(eventId, getDocFpType());
          case 9:
            $scope.shouldShowTimeShiftButton = _context.sent;
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _initButtons.apply(this, arguments);
  }
  initButtons();
  $scope.applyFpStatusToSelectedItems = function (fpStatusToApply, attributeName) {
    if (!attributeName) {
      attributeName = 'fp_status';
    }
    var promises = [];
    var selectedItems = getAllSelectedItems();
    var privateFields = getPrivateFields();
    selectedItems.forEach(function (_row) {
      delete _row.isSelected;
      var clonedRow = deleteMetaPropsInRow(_.clone(_row), privateFields);
      clonedRow[attributeName] = fpStatusToApply;
      var p = bulkUpdateService.updateDoc(eventId, event.node, _row.fp_type, clonedRow);
      promises.push(p);
      p.then(function () {
        return _row[attributeName] = clonedRow[attributeName];
      });
    });
    return $q.all(promises).then(function () {
      $scope.onStatusChange({
        status: fpStatusToApply,
        selectedItems: selectedItems
      });
      return $scope.$emit('selectionChange');
    });
  };

  /** @param {'approve' | 'deny'} action */
  $scope.setPaxRequestStatus = function (action) {
    var items = getAllSelectedItems() || [];
    if (!items.length || !['approve', 'deny'].includes(action)) {
      return;
    }
    var msgAction = action === 'approve' ? 'approved' : 'denied';
    var msg = "The selected requests will be ".concat(msgAction, ". Proceed?");
    if (!confirm(msg)) {
      return;
    }
    var paxRequestIds = items.map(function (d) {
      return d._id;
    });
    window.BSTG.services.pax.setPaxRequestStatus(eventId, paxRequestIds, action).then(function () {
      return _this.$timeout(function () {
        return $route.reload();
      }, 1000);
    }).catch(function () {
      return alert('The requests could not be approved');
    });
  };
  $scope.deleteSelectedItems = function () {
    var items = getAllSelectedItems() || [];
    if (!items.length) {
      return;
    }
    if (!confirm('The selected items will be removed or deactivated. Proceed?')) {
      return;
    }
    if (getDocFpType() === 'person') {
      return $scope.applyFpStatusToSelectedItems('cancelled');
    } else {
      // the app side expects docs to have been actually deleted if they're not pax
      // we can safely assume that all fp_types are the same here
      var fpType = items[0].fp_type;
      var fpExtIds = items.map(function (_row) {
        return _row.fp_ext_id;
      });
      return bulkUpdateService.deleteDocs(eventId, event.node, fpType, fpExtIds).then(function () {
        $rootScope.setFlashMessage('The selected items were removed.');
        $scope.hideSelectedItemsInList();
        $scope.onDeleteOrDesactivate({
          selectedItems: items
        });
        return $route.reload();
      }, function () {
        return alert('Error! The selected items could not be deleted. Do they have ids?');
      });
    }
  };
  $scope.openModalDuplicate = function () {
    var items = getAllSelectedItems() || [];
    var fpType = getDocFpType();
    if (!items.length) {
      return;
    }
    metricsService.track('duplicate_start', {
      countSelectedItems: items.length,
      dataType: fpType
    });
    modalService.openModal({
      scope: {
        selectedItems: items,
        dataType: fpType,
        eventId: eventId
      },
      templateUrl: '/static/partials/components/modal-duplicate.html'
    }).then(function () {
      return _this.$timeout(function () {
        return _this.$window.location.reload();
      }, 1500);
    });
  };
  $scope.openModalBulkEdit = function () {
    var items = getAllSelectedItems() || [];
    var fpType = getDocFpType();
    if (!items.length || items.length < 2) {
      return;
    }
    metricsService.track('bulk_edit_start', {
      countSelectedItems: items.length,
      dataType: fpType
    });
    var metadataForType = metadataService.getCachedMetadataForTypeAsArray(eventId, fpType).filter(function (field) {
      return field._bulk_edit !== false && field.kind !== 'custom';
    });
    var metadataFields = metadataService.filterDuplicateTargetsExceptionsFields(metadataForType);
    modalService.openModal({
      scope: {
        selectedItems: items,
        dataType: fpType,
        metadataFields: metadataFields,
        eventId: eventId
      },
      templateUrl: '/static/partials/components/modal-bulk-edit.html'
    }).then(function () {
      // need a better way to reload the results
      // $route.reload seems to only reloads the list already created, and we need to refresh the whole list
      _this.$timeout(function () {
        return _this.$window.location.reload();
      }, 1500);
    });
  };
  $scope.openModalTimeShift = function () {
    var items = getAllSelectedItems() || [];
    var fpType = getDocFpType();
    if (!items.length) {
      return;
    }
    metricsService.track('time_shift_start', {
      countSelectedItems: items.length,
      dataType: fpType
    });
    modalService.openModal({
      scope: {
        selectedItems: items,
        eventId: eventId,
        dataType: fpType,
        timeShiftFields: $scope.timeShiftFields
      },
      templateUrl: '/static/partials/components/modal-time-shift.html'
    }).then(function () {
      return _this.$timeout(function () {
        return _this.$window.location.reload();
      }, 1500);
    });
  };
  var bulkAssociationFields = metadataService.getCachedMetadataForTypeAsArray(eventId, getDocFpType()).filter(function (mdField) {
    return mdField.kind === 'external' && (!mdField.kind_options || mdField.kind_options.type !== 'targets-exceptions');
  });
  $scope.getFieldsForBulkAssociation = function () {
    return bulkAssociationFields;
  };
  $scope.closeBulkAssociationModalAndPerformAssociation = function () {
    var selectedBulkAssociationField = $scope.selectedBulkAssociationField;
    if (!selectedBulkAssociationField) {
      return $scope.showBulkAssociationModal = false;
    }
    if (!confirm('This will associate the selected items with the one you have chosen. Are you sure?')) {
      return;
    }
    var getSelectedItemIdValue = function getSelectedItemIdValue(item, fieldDescriptor) {
      var idField = (fieldDescriptor.kind_options ? fieldDescriptor.kind_options.id_field : undefined) || 'fp_ext_id';
      return item[idField];
    };
    $scope.bulkAssociationInProgress = true;
    // loop through the selected items and make the appropriate associations
    var items = getAllSelectedItems();
    items.forEach(function (item) {
      var val = getSelectedItemIdValue($scope.selectedBulkAssociationItem, selectedBulkAssociationField);
      var singleDoc = (selectedBulkAssociationField.kind_options || {}).single_doc;
      if (singleDoc) {
        item[selectedBulkAssociationField.field] = val;
      } else {
        var arr = item[selectedBulkAssociationField.field];
        if (_.isArray(arr)) {
          if (!arr.includes(val)) {
            arr.push(val);
          }
        } else {
          item[selectedBulkAssociationField.field] = [val];
        }
      }
      if (item.isSelected) {
        return delete item.isSelected;
      }
    });
    // and save 'em all up
    return bulkUpdateService.createDocs(eventId, event.node, getDocFpType(), items, {
      keepId: true
    }).then(function () {
      return $scope.showBulkAssociationModal = $scope.bulkAssociationInProgress = false;
    }, function () {
      $scope.bulkAssociationInProgress = false;
      return alert('An error occurred.');
    });
  };
  $scope.$watch('selectedBulkAssociationField', function (selectedFieldDescriptor) {
    if (!_.isObject(selectedFieldDescriptor)) {
      return;
    }
    var type = (selectedFieldDescriptor.kind_options || {}).type;
    return eventService.getEventDocsByType(event, type).then(function (data) {
      return $scope.bulkAssociationItems = data.data;
    }, function () {
      return alert('An error occurred.');
    });
  });
};
tableItemSelectionActionsCtrl.$inject = ["$route", "$routeParams", "$scope", "$q", "$rootScope", "$window", "$timeout", "eventService", "metadataService", "bulkUpdateService", "metricsService", "modalService"];
module.exports = function () {
  return {
    transclude: true,
    scope: {
      rowCollection: '=',
      showPaxArrivedButton: '=',
      hideAssociateWithOtherItems: '=',
      somethingSelected: '=?',
      onStatusChange: '&',
      onDeleteOrDesactivate: '&',
      transclude: '='
    },
    templateUrl: '/static/partials/components/table-item-selection-actions.html',
    controller: tableItemSelectionActionsCtrl
  };
};